export function multiplyEmailsValidate() {
    return {
        require: 'ngModel',
        link: function(scope, element, attrs, ctrl ) {
            var emailsRegex = /^[_a-zA-Z0-9]+(\.[_a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,61})$/;
            ctrl.$parsers.unshift(function(viewValue) {

                var emails = viewValue.split(',');
                // angular.foreach(emails, function() {
                var validityArr = emails.map(function(str){
                    return emailsRegex.test(str.trim());
                }); // sample return is [true, true, true, false, false, false]

                var atLeastOneInvalid = false;
                angular.forEach(validityArr, function(value) {
                    if(value === false)
                        atLeastOneInvalid = true;
                });
                if(!atLeastOneInvalid) {

                    ctrl.$setValidity('MULTIPLY', true);
                    return viewValue;
                } else {
                    ctrl.$setValidity('MULTIPLY', false);
                    return undefined;
                }
            });
        }
    };
}



// WEBPACK FOOTER //
// ./src/ui/directives/multiply-emails-validate.directive.js